import styled from 'styled-components'
import { Style } from '../../styles'

const TabItems = styled.div`
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid ${Style.color.border};
`

export default TabItems